import { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";

const GraficoFrequenciaDia = ({ dados, tipo, onBarClick, minimo, ideal }) => {
    const chartRef = useRef(null);
    const chartInstanceRef = useRef(null);

    useEffect(() => {
        if (!dados || dados.length === 0 || !chartRef.current) return;

        const labels = dados.map((item) =>
            new Date(item.data).toLocaleDateString("pt-BR")
        );

        const valores = dados.map((item) =>
            item.totalHoras ? Number(item.totalHoras.toFixed(2)) : 0
        );

        const media =
            valores.length > 0
                ? valores.reduce((a, b) => a + b, 0) / valores.length
                : 0;

        const ctx = chartRef.current.getContext("2d");

        if (chartInstanceRef.current) {
            // Atualiza os dados e linhas constantes
            chartInstanceRef.current.data.labels = labels;
            chartInstanceRef.current.data.datasets[0].data = valores;
            // chartInstanceRef.current.data.datasets[1].data = Array(labels.length).fill(media);
            chartInstanceRef.current.data.datasets[2].data = Array(labels.length).fill(minimo);
            chartInstanceRef.current.data.datasets[3].data = Array(labels.length).fill(ideal);
            chartInstanceRef.current.update();
        } else {
            chartInstanceRef.current = new Chart(ctx, {
                type: tipo,
                data: {
                    labels,
                    datasets: [
                        {
                            label: "Horas Totais da Turma por Dia",
                            data: valores,
                            backgroundColor: "#0B6B9D",
                            borderColor: "#0B6B9D",
                            borderWidth: 2,
                            fill: false,
                            tension: tipo === "line" ? 0.3 : 0,
                            ...(tipo === "bar" && {
                                barThickness: 20,
                                categoryPercentage: 0.8,
                                barPercentage: 0.9,
                            }),
                        },
                        // {
                        //     type: "line",
                        //     label: "Média da Turma",
                        //     data: Array(labels.length).fill(media),
                        //     borderColor: "orange",
                        //     borderDash: [5, 5],
                        //     borderWidth: 2,
                        //     pointRadius: 0,
                        //     fill: false,
                        //     tension: 0,
                        // },
                        {
                            type: "line",
                            label: "Mínimo Requerido (Horas)",
                            data: Array(labels.length).fill(minimo),
                            borderColor: "red",
                            borderWidth: 2,
                            pointRadius: 0,
                            fill: false,
                            tension: 0,
                        },
                        {
                            type: "line",
                            label: "Ideal (100% Presença)",
                            data: Array(labels.length).fill(ideal),
                            borderColor: "green",
                            borderDash: [2, 2],
                            borderWidth: 2,
                            pointRadius: 0,
                            fill: false,
                            tension: 0,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                        duration: 800,
                        easing: "easeOutQuart",
                    },
                    plugins: {
                        title: {
                            display: true,
                            text: "Frequência Diária da Turma",
                            font: { size: 16 },
                        },
                        legend: {
                            labels: {
                                font: { size: 14 },
                            },
                        },
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    return `${context.dataset.label}: ${context.formattedValue}h`;
                                },
                            },
                        },
                    },
                    onClick: (event, elements) => {
                        if (elements.length > 0) {
                            const index = elements[0].index;
                            const dataSelecionada = dados[index].data;
                            onBarClick && onBarClick(dataSelecionada);
                        }
                    },
                    scales: {
                        x: {
                            title: {
                                display: true,
                                text: "Data",
                                font: { size: 14 },
                            },
                            ticks: { font: { size: 12 }, maxRotation: 45 },
                            grid: { display: false },
                        },
                        y: {
                            beginAtZero: true,
                            title: {
                                display: true,
                                text: "Horas",
                                font: { size: 14 },
                            },
                            ticks: { stepSize: 2 },
                        },
                    },
                },
            });
        }

        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
                chartInstanceRef.current = null;
            }
        };
    }, [dados, tipo, minimo, ideal, onBarClick]);

    return <canvas ref={chartRef}></canvas>;
};

export default GraficoFrequenciaDia;
